import type { Subcategory } from '~/entities/categories'

export function getSatisfyingCategory({
  phase,
  outcome,
  reason,
  subcategories,
}: {
  phase: string
  outcome?: string
  reason?: string
  subcategories: Subcategory[]
}) {
  const satisfyingCategories = subcategories.filter(
    ({ metadata }) =>
      metadata.phase.label === phase &&
      (!outcome || metadata.outcome.label === outcome) &&
      (!reason || metadata.reason.label === reason),
  )

  // Prefer an active category: a partially specified facet set matches several leaves, and
  // the first of them is deprecated for Prior Auth Appeal / Request / Denied Upheld — so
  // picking a valid phase or outcome would otherwise land the form on a retired category.
  // Falls back to the first match so an all-deprecated bucket still resolves for display.
  const satisfyingCategory =
    satisfyingCategories.find(({ deprecated }) => !deprecated) ?? satisfyingCategories[0]

  return satisfyingCategory?.label || ''
}
